import {Tag} from "@/store/forum/types";
import {Tr} from "@/i18n/i18n";

export class ForumUtils {

    public static readonly COMMON_FORUM_ID = -1001;

    public static readonly COMMON_TAGS: Tag[] = [Tag.NEWS, Tag.SUGGESTIONS, Tag.GAME_DISCUSSIONS, Tag.HELP, Tag.QUESTIONS, Tag.TALK,
        Tag.PLAY, Tag.MEET, Tag.COMPETITION, Tag.RULES, Tag.CHRONICLES];

    public static readonly CLAN_TAGS: Tag[] = [Tag.CLAN_INFO, Tag.CLAN_STUFF, Tag.CLAN_TALK, Tag.CLAN_OTHER];

    public static getAvailableTags(clanId: number | undefined) {
        return (clanId && clanId !== ForumUtils.COMMON_FORUM_ID) ? ForumUtils.CLAN_TAGS : ForumUtils.COMMON_TAGS
    }

    public static tagsToString(tags: Tag[]) {
        let res = '#';

        for (let t of tags) {
            res += this.getTagName(t);
            res += ', #';
        }

        if (res.length > 0) {
            res = res.substr(0, res.length - 3);
        }

        return res;
    }

    public static getTagName(tag: Tag): string {
        switch (tag) {
            case Tag.NEWS:
                return Tr('ft.news');
            case Tag.SUGGESTIONS:
                return Tr('ft.sugg');
            case Tag.GAME_DISCUSSIONS:
                return Tr('ft.disc');
            case Tag.TALK:
                return Tr('ft.talk');
            case Tag.PLAY:
                return Tr('ft.play');
            case Tag.HELP:
                return Tr('ft.help');
            case Tag.QUESTIONS:
                return Tr('ft.quest');
            case Tag.MEET:
                return Tr('ft.meet');
            case Tag.COMPETITION:
                return Tr('ft.comp');
            case Tag.RULES:
                return Tr('ft.rules');
            case Tag.CLAN_INFO:
                return Tr('ft.cl.info');
            case Tag.CLAN_STUFF:
                return Tr('ft.cl.stuff');
            case Tag.CLAN_TALK:
                return Tr('ft.cl.talk');
            case Tag.CLAN_OTHER:
                return Tr('ft.cl.oth');
            case Tag.CHRONICLES:
                return Tr('ft.letopis');
        }
        return 'Unknown.';
    }

}
